export const appointmentTypeColumns = [
  {
    title: 'Appointment Type',
    key: 'title',
    dataIndex: 'title'
  }
];
